import { AccountDetailsTableRow } from '@/ui/features/background-check/components/background-check-modal/components/AccountDetailsTableRow';
import { useAccountDetailsFields } from '@/ui/features/background-check/components/background-check-modal/hooks/useAccountDetailsFields';
import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { AccountData } from '@juvare/contact-management/backend/features/accounts/shared';
import { Table, TableBody, TableContainer } from '@mui/material';
import get from 'lodash/get';
import React from 'react';
import { ZodFormattedError } from 'zod';

export type ValidationErrors =
    | ZodFormattedError<{
          dateOfBirth: string;
          email: string;
          firstName: string;
          lastName: string;
          stateOfWork: string;
          address?: { addressLine1: string; city: string; state: string; postalCode: string };
          ssn?: string | undefined;
      }>
    | undefined;

interface BackgroundCheckAccountDetailsProps {
    account: AccountData;
    validationErrors: ValidationErrors;
    showValidationErrors?: boolean;
}

export const BackgroundCheckAccountDetails: React.FC<BackgroundCheckAccountDetailsProps> = ({
    account,
    validationErrors,
    showValidationErrors = true,
}) => {
    const fields = useAccountDetailsFields();

    return (
        <TableContainer sx={{ backgroundColor: themeColors.surface.secondary }}>
            <Table size='small'>
                <TableBody>
                    {fields.map(({ key, label }) => (
                        <AccountDetailsTableRow
                            key={key}
                            path={key}
                            label={label}
                            account={account}
                            error={showValidationErrors ? get(validationErrors, key)?._errors?.[0] : undefined}
                        />
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};
